// client/src/components/shared/PwaUpdateBanner.js — "A new version is ready — Reload".
//
// Shown on every page (App.js) when a new deploy's service worker has installed and is
// waiting (client/src/pwa/). Reload hands over to it and reloads once. "Later" hides the
// banner; the new version then takes over the next time the app is opened from scratch.
import React, { useState } from 'react';
import { usePwaState, reloadToUpdate } from '../../pwa/registerServiceWorker';

const PwaUpdateBanner = () => {
    const { waitingWorker } = usePwaState();
    const [hidden, setHidden] = useState(null);
    if (!waitingWorker || hidden === waitingWorker) return null;
    return (
        <div role="status" aria-live="polite"
            className="fixed z-50 left-1/2 -translate-x-1/2 bottom-4 w-[calc(100%-2rem)] max-w-md bg-slate-900 text-white rounded-lg shadow-lg px-4 py-3 flex items-center gap-3 justify-between"
            style={{ marginBottom: 'env(safe-area-inset-bottom)' }}>
            <span className="text-sm">A new version is ready — Reload</span>
            <span className="flex gap-2 flex-shrink-0">
                <button type="button" onClick={reloadToUpdate} className="px-4 py-2 min-h-[40px] bg-slate-700 hover:bg-indigo-400 rounded-md text-sm font-medium">Reload</button>
                <button type="button" onClick={() => setHidden(waitingWorker)} className="px-3 py-2 min-h-[40px] text-slate-300 hover:text-white text-sm">Later</button>
            </span>
        </div>
    );
};

export default PwaUpdateBanner;
